module.exports = __webpack_public_path__ + "img/8.e3cc292.jpg";